export function recordStagingPerformance(stage, detail = {}) {
  if (typeof window === "undefined" || import.meta.env.MODE !== "staging") return;

  const history = Array.isArray(window.__AFRIMED_PERFORMANCE_TRACE__)
    ? window.__AFRIMED_PERFORMANCE_TRACE__
    : [];

  window.__AFRIMED_PERFORMANCE_TRACE__ = [
    ...history.slice(-99),
    {
      atMs: Math.round(performance.now()),
      route: window.location.pathname,
      stage,
      ...detail,
    },
  ];
}
